import * as _ from 'lodash';
import { BaseModel } from './base-model';

export class ModelFactory {
  public static newInstance<T extends BaseModel>(
    cls: { new (): T },
    values: any = {}
  ): T {
    const instance: any = new cls();
    const deps = instance.dependencies;
    _.assign(instance, values);
    Object.keys(deps || {}).forEach((key) => {
      if (Object.keys(values || {}).includes(key)) {
        if (_.isArray(values[key])) {
          instance[key] = ModelFactory.newInstances(deps[key], values[key]);
        } else {
          instance[key] = ModelFactory.newInstance(deps[key], values[key]);
        }
      }
    });
    instance.init();
    return instance;
  }

  public static newInstances<T extends BaseModel>(
    cls: { new (): T },
    values: Array<any>
  ): Array<T> {
    return values.map((v) => ModelFactory.newInstance(cls, v));
  }
}
